import React, { useMemo } from 'react';

const CONFETTI_COLORS = ['#7f8bff', '#7ed8ff', '#ffcf66', '#8ee09b', '#ff9fcb', '#b5a0ff'];
const CONFETTI_COUNT = 26;

const buildConfettiPieces = () =>
  Array.from({ length: CONFETTI_COUNT }, (_, index) => {
    const left = (index * 17 + 11) % 100;
    const driftDirection = index % 2 === 0 ? 1 : -1;
    const drift = driftDirection * (16 + ((index * 7) % 18));
    const delayMs = (index * 170) % 2000;
    const durationMs = 3400 + (index % 6) * 500;
    const sizePx = 6 + (index % 4) * 2;
    const rotateDeg = (index * 37) % 360;

    return {
      id: `confetti-${index}`,
      color: CONFETTI_COLORS[index % CONFETTI_COLORS.length],
      left,
      drift,
      delayMs,
      durationMs,
      sizePx,
      rotateDeg,
    };
  });

const DailyCheckinConfetti = ({ active = true }) => {
  const confettiPieces = useMemo(buildConfettiPieces, []);

  if (!active) return null;

  return (
    <div className="daily-checkin-confetti" aria-hidden="true">
      {confettiPieces.map((piece) => (
        <span
          key={piece.id}
          className="daily-checkin-confetti__piece"
          style={{
            '--confetti-color': piece.color,
            '--confetti-left': `${piece.left}%`,
            '--confetti-drift': `${piece.drift}px`,
            '--confetti-delay': `${piece.delayMs}ms`,
            '--confetti-duration': `${piece.durationMs}ms`,
            '--confetti-size': `${piece.sizePx}px`,
            '--confetti-rotate': `${piece.rotateDeg}deg`,
          }}
        />
      ))}
    </div>
  );
};

export default DailyCheckinConfetti;
